import { createGlobalStyle } from '@xstyled/styled-components';

export const Typography = createGlobalStyle`
  h1 {
    font-family: ${p => p.theme.fonts.title};
    font-size: 36px;
    font-weight: normal;
    line-height: 49px;
    margin: 0;
  }

  h2 {
    font-family: ${p => p.theme.fonts.title};
    font-size: 24px;
    font-weight: normal;
    line-height: 28px;
    margin: 0;
  }

  h3 {
    font-family: ${p => p.theme.fonts.title};
    font-size: 18px;
    font-weight: normal;
    line-height: 150%;
    margin: 0;
  }

  h4 {
    font-family: ${p => p.theme.fonts.title};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;  
    margin: 0;
  }

  h5 {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 16px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    margin: 0;
  }

  body {
    font-family: ${p => p.theme.fonts.default};
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 150%;
    color: var(--color-black)
  }

  small {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 150%;
  }

  button {
    font-family: ${p => p.theme.fonts.default};
    font-size: 16px;
  }
  
  @media (max-width: sm) {
    h1 {
      font-size: 26px;
      line-height: 39px;
    }
    
    h2 {
      font-size: 14px;
      line-height: 18px;
    }
  }
  
  .pb-5 {
    padding-bottom: 20px;
  }
  .pt-5 {
    padding-top: 20px;
  }
  .mb-5 {
    margin-bottom: 20px;
  }
  .mt-5 {
    margin-top: 20px;
  }
  .hidden {
    display: none;
  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
    top: -100px;
    visibility: hidden;
  }
`;
